export enum ModalType {
    Login = 'Login',
    Splash = 'Splash',
    User = 'User',
    Cashier = 'Cashier',
    Balance = 'Balance',
    Inbox = 'Inbox',
    BottomMenu = 'Bottom Menu',
    Promo = 'Promo'
}